import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { DataService } from '../../../core/service/base/data.service';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { PriceList } from '../../model/pricelist';
import { PriceListItem } from '../../model/pricelistitem';

@Injectable()
export class PriceListService extends DataService<PriceList> {
  constructor(
    client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    private messageService: MessageService,
    progressBar: ProgressBarService
  ) {
    super(client, config, messageService, PriceList, progressBar, 'price-list');
  }

  protected createModel(context: any): PriceList {
    return new PriceList(context);
  }

  importSabo(file: File, name: string): Observable<any> {
    const formData = new FormData();
    formData.append('name', name);
    formData.append('document', file, file.name);
    this.progressBar.start();
    return this.client.post<any>(`${this.endpoint}/import-sabo`, formData).pipe(
      catchError(e => {
        this.messageService.showError(e);
        throw e;
      }),
      tap(r => this.messageService.showSuccess()),
      finalize(() => this.progressBar.stop())
    );
  }

  getValidForProperty(propertyId: string): Observable<PriceList[]> {
    this.progressBar.start();
    return this.client.get<PriceList[]>(this.endpoint + '/property/' + propertyId).pipe(
      map(response => this.toModels(response)),
      finalize(() => this.progressBar.stop())
    );
  }

  getValidForObject(rentalObjectId: string): Observable<PriceList[]> {
    this.progressBar.start();
    return this.client.get<PriceList[]>(this.endpoint + '/dwelling/' + rentalObjectId).pipe(
      map(response => this.toModels(response)),
      finalize(() => this.progressBar.stop())
    );
  }

  getPriceListItem(itemId: string): Observable<PriceListItem> {
    if (!itemId) return of(null);
    return this.client.get<PriceListItem>(`${this.endpoint}/list-item/${itemId}`).pipe(map(response => new PriceListItem(response)));
  }
}
